import React from 'react';
import { X, AlertCircle, Edit3, MessageCircle, Check, FileText } from 'lucide-react';
import { analyzeResumeGaps } from '../../utils/progressSync';
import { getProgressItems } from '../../utils/resumeProgressUtils';
import LatteButton from './LatteButton';

const ProgressGuideModal = ({ 
  isOpen, 
  onClose, 
  actualProgress, 
  resumeData,
  featureName = '이 기능', // PDF 다운로드, 웹페이지 생성, 영어 버전 생성 등
  onContinueConsulting,
  onEdit,
  buttonText = 'AI 컨설팅 계속하기', // 버튼 텍스트 커스터마이징
  showOnlyCompleted = false, // 100% 완료시에도 버튼 표시 여부
  hideWarningMessage = false // 경고 메시지 숨기기
}) => {
  if (!isOpen) return null;

  const progressItems = getProgressItems(resumeData);
  
  return (
    <div className="fixed inset-0 z-[9999] flex items-end sm:items-center justify-center">
      {/* 오버레이 */}
      <div 
        className="absolute inset-0 bg-black bg-opacity-50 transition-opacity"
        onClick={onClose}
      />
      
      {/* 모달 컨텐츠 */}
      <div className="relative bg-white w-full sm:max-w-md mx-auto rounded-t-2xl sm:rounded-2xl shadow-xl transform transition-all">
        {/* 헤더 */}
        <div className="px-6 py-4">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-xl font-bold text-gray-900">
              진행 상황
            </h3>
            <button
              onClick={onClose}
              className="p-1 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <X className="w-5 h-5 text-gray-500" />
            </button>
          </div>
        
          {/* 안내 메시지 */}
          {actualProgress < 100 && !hideWarningMessage && (
            <div className="mb-4 bg-amber-50 rounded-lg p-4">
              <p className="text-sm text-amber-800 font-medium">
                {featureName}을 사용하려면 이력서를 100% 완성해야 합니다.
              </p>
            </div>
          )}
          
          {/* 진행률 표시 */}
          <div className="mb-6">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-medium text-gray-700">진행률</span>
              <span className="text-2xl font-bold text-amber-600">{actualProgress}%</span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
              <div 
                className="bg-gradient-to-r from-amber-500 to-amber-600 h-full rounded-full transition-all duration-300"
                style={{ width: `${actualProgress}%` }}
              />
            </div>
          </div>
          
          {/* 진행 상황 아이템 리스트 */}
          <div className="space-y-3">
            {progressItems.map((item) => (
              <div key={item.key} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0">
                <span className="text-sm font-medium text-gray-700">{item.name}</span>
                <Check 
                  size={20} 
                  className={`${
                    item.completed 
                      ? 'text-green-500' 
                      : 'text-gray-300'
                  }`}
                />
              </div>
            ))}
          </div>
        </div>
        
        {/* 푸터 */}
        <div className="px-6 py-4 border-t border-gray-100">
          {(actualProgress < 100 || showOnlyCompleted) ? (
            <LatteButton
              onClick={() => {
                onClose();
                if (onContinueConsulting) onContinueConsulting();
              }}
              variant="primary"
              className="w-full bg-amber-600 hover:bg-amber-700 text-white"
            >
              {buttonText === '이력서 보기' ? (
                <FileText className="w-4 h-4" />
              ) : (
                <MessageCircle className="w-4 h-4" />
              )}
              {buttonText}
            </LatteButton>
          ) : (
            <LatteButton
              onClick={onClose}
              variant="secondary"
              className="w-full"
            >
              닫기
            </LatteButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressGuideModal;